// Build a universal Google Maps search URL for an arena + address.
// No API key required — this is the public maps URL scheme, which opens
// Google Maps in the browser or hands off to the device's native map app
// (Apple Maps on iOS, Google Maps on Android). Returns null when there's
// nothing to search so callers can render plain text instead of a dead link.
export function mapsUrl(name, address) {
  const q = [name, address].filter(Boolean).join(' ').trim();
  if (!q) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}
